import beyaz from "../assets/makina/koku-beyaz.jpeg";
import gri from "../assets/makina/koku-gri.jpeg";
import sari from "../assets/makina/koku-sari.jpeg";
import pembe from "../assets/makina/koku-pembe.jpeg";
import turuncu from "../assets/makina/koku-turuncu.jpeg";
import camDigital from "../assets/makina/koku-cam-digi.jpeg";
import digital from "../assets/makina/koku-digi.jpeg";
import amerikan from "../assets/makina/amerikan.jpeg";
import mak100 from "../assets/makina/mak100.jpeg";
import sa100 from "../assets/makina/sa100.jpeg";

// yeniler
import gold from "../assets/makina/gold.jpeg";
import silver from "../assets/makina/silver.jpeg";
import bronz from "../assets/makina/bronz.jpeg";
import pink from "../assets/makina/pink.jpeg";
import black from "../assets/makina/black.jpeg";

export const resimler = {
    beyaz,
    gri,
    sari,
    pembe,
    turuncu,
    camDigital,
    digital,
    gold,
    silver,
    bronz,
    pink,
    black,
    amerikan,
    mak100,
    sa100,
};
